import "@/styles/packages.scss"

import { application } from "../helpers/stimulus"

import { setupAccordions } from "@/components/content/Accordion"
import DisclosureItemController from "../controllers/disclosure_item_controller"
import ModalController from "../controllers/modal_controller"
import ModalTriggerController from "../controllers/modal_trigger_controller"
import TooltipController from "../controllers/tooltip_controller"
import VoucherFormController from "../controllers/voucher_form_controller"

const setupStimulus = (): void => {
  application.register("disclosure-item", DisclosureItemController)
  application.register("facilities-modal", ModalController)
  application.register("facilities-modal-trigger", ModalTriggerController)
  application.register("tooltip", TooltipController)
  application.register("voucher-form", VoucherFormController)
}

setupStimulus()
setupAccordions()
